export default "__VITE_ASSET__CWcaZdr1__"